import { render, staticRenderFns } from "./PasswordPage.vue?vue&type=template&id=079210eb&scoped=true&"
import script from "./PasswordPage.vue?vue&type=script&lang=js&"
export * from "./PasswordPage.vue?vue&type=script&lang=js&"
import style0 from "./PasswordPage.vue?vue&type=style&index=0&id=079210eb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079210eb",
  null
  
)

export default component.exports